import { Flex } from 'antd';
import styles from './useTableColumns.module.scss';
import { Tooltip } from '../../common';
import { shortenText } from 'utils';

const HoverTooltip = ({ children, title }) => {
  return (
    <Tooltip color={'var(--user-table-bg)'} title={title} overlayStyle={{ maxWidth: 500 }}>
      {children}
    </Tooltip>
  );
};

const RenderMultipleFilters = ({ data = {} }) => {
  const dataKeys = Object.keys(data);
  if ((dataKeys || [])?.length === 0) return '-';
  const isSingleFilter = dataKeys?.length === 1;
  const limit = 20;

  const renderFilterItem = (filterText, isTruncate = false) => {
    const { displayText } = shortenText(filterText, limit);

    return (
      <div className={styles.filterChip}>
        <span className={'body-12-medium'}>{isTruncate ? displayText : filterText}</span>
      </div>
    );
  };

  const renderTooltipTitle = () => (
    <Flex gap={4} wrap>
      {dataKeys?.map((key) => renderFilterItem(`${key}: ${data?.[key]}`))}
    </Flex>
  );

  const firstKey = dataKeys?.[0];
  const text = typeof data?.[firstKey] === 'string' ? `${firstKey}: ${data?.[firstKey]}` : '-';

  return (
    <Flex align="center" gap={4}>
      <HoverTooltip title={isSingleFilter ? renderTooltipTitle() : ''}>{renderFilterItem(text, true)}</HoverTooltip>
      {!isSingleFilter && (
        <HoverTooltip title={renderTooltipTitle()}>
          <Flex className={styles.moreButton}>+{dataKeys?.length - 1}</Flex>
        </HoverTooltip>
      )}
    </Flex>
  );
};

export default RenderMultipleFilters;
